<template>
  <b-form>
    <b-form-group label="Заголовок" id="post-form-title">
      <b-form-input v-model="model.title" @change="apply()"></b-form-input>
    </b-form-group>
    <b-form-group label="Вступление" id="post-form-excerpt">
      <text-editor v-model="model.excerpt" class="excerpt" @input="apply()"></text-editor>
    </b-form-group>
    <b-form-group label="Статья" id="post-form-article">
      <text-editor v-model="model.article" class="article" @input="apply()" full></text-editor>
    </b-form-group>
  </b-form>
</template>

<script>
import TextEditor from '@/components/Editor'

export default {
  components: {
    TextEditor
  },
  model: {
    prop: 'post',
    event: 'apply'
  },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    model: {
      id: '',
      title: '',
      excerpt: '',
      article: ''
    }
  }),
  beforeMount () {
    this.model = this.post
  },
  methods: {
    apply () {
      this.$emit('apply', this.model)
    }
  }
}
</script>

<style lang="scss">
#post-form-excerpt {
  .ck-editor {
    .ck-content {
      height: 6rem;
    }
  }
}
</style>
